import ExcelJS from 'exceljs';

export const WagesReportExcel = (filteredData) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Shtoni titullin e kolonave në rreshtin e parë
    // worksheet.mergeCells('A1', 'A2');
    // const cellA1A2 = worksheet.getCell('A1');

    // cellA1A2.value = 'NR.';
    // cellA1A2.width = 50; // Përcakton width në 100 piksela
    // cellA1A2.height = 125; // Përcakton height në 50 piksela
    // cellA1A2.border = {
    //     top: { style: 'thin', color: { argb: '00000000' }, bold: true },
    //     left: { style: 'thin', color: { argb: '00000000' }, bold: true },
    //     bottom: { style: 'thin', color: { argb: '00000000' }, bold: true },
    //     right: { style: 'thin', color: { argb: '00000000' }, bold: true }
    // };
    // cellA1A2.alignment = {
    //     vertical: 'middle',
    //     horizontal: 'center',
    //     wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    // };


    const cellA1 = worksheet.getCell('A1');
    cellA1.value = 'Emri';
    cellA1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellA1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };

    const cellA2 = worksheet.getCell('A2');
    cellA2.value = 'a';
    cellA2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellA2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };



    const cellB1 = worksheet.getCell('B1');
    cellB1.value = 'Mbiemri';
    cellB1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellB1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };

    const cellB2 = worksheet.getCell('B2');
    cellB2.value = 'b';
    cellB2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellB2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };



    const cellC1 = worksheet.getCell('C1');
    cellC1.value = 'Numri Individual i punëtorit';
    cellC1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellC1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellC1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellC2 = worksheet.getCell('C2');
    cellC2.value = 'c';
    cellC2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellC2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellD1 = worksheet.getCell('D1');
    cellD1.value = 'Bruto paga për muaj';
    cellD1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellD1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellD1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellD2 = worksheet.getCell('D2');
    cellD2.value = 'd';
    cellD2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellD2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };



    const cellE1 = worksheet.getCell('E1');
    cellE1.value = 'Kontributi pensional i të punësuarit';
    cellE1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellE1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellE1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellE2 = worksheet.getCell('E2');
    cellE2.value = 'e=(d*5%)';
    cellE2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellE2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };

    const cellF1 = worksheet.getCell('F1');
    cellF1.value = 'Kontributi pensional i punëdhënësit';
    cellF1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellF1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellF1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellF2 = worksheet.getCell('F2');
    cellF2.value = 'f=(d*5%)';
    cellF2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellF2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };

    const cellG1 = worksheet.getCell('G1');
    cellG1.value = 'Kontributi suplementar i të punësuarit';
    cellG1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellG1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellG1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellG2 = worksheet.getCell('G2');
    cellG2.value = 'g';
    cellG2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellG2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };

    const cellH1 = worksheet.getCell('H1');
    cellH1.value = 'Kontributi suplementar i punëdhënësit';
    cellH1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellH1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellH1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellH2 = worksheet.getCell('H2');
    cellH2.value = 'h';
    cellH2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellH2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellI1 = worksheet.getCell('I1');
    cellI1.value = 'Punë Primare';
    cellI1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellI1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellI1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellI2 = worksheet.getCell('I2');
    cellI2.value = 'h';
    cellI2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellI2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellJ1 = worksheet.getCell('J1');
    cellJ1.value = 'Përfshihen Kontributet';
    cellJ1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellJ1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellJ1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellJ2 = worksheet.getCell('J2');
    cellJ2.value = 'j';
    cellJ2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellJ2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellK1 = worksheet.getCell('K1');
    cellK1.value = 'Aplikohet Tatimi në Paga';
    cellK1.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellK1.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true // Lejon tekstin të shpërfaqet në disa rreshta nëse është shumë i gjatë
    };
    cellK1.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };


    const cellK2 = worksheet.getCell('K2');
    cellK2.value = 'k';
    cellK2.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    };
    cellK2.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFECE9D8' } // Ngjyra e hirit
    };

    // Përdorni map për të shtuar rreshtat e të dhënave
    filteredData.map((item, index) => {
        const row = [];
        // Shtoni vlerat për secilën kolonë bazuar në të dhënat e furnizuara
        row.push(item.Emri || '');
        // row.push(item.ActionType === 'IND' ? `IND-2024-${item.NumriFatures}` : item.NumriFatures || '')
        row.push(item.Mbiemri || '');
        row.push(item.NumriPersonal || '');
        row.push(item.PagaBruto || '');
        row.push(item.KontributiPunetorit || '');
        row.push(item.KontributiPunedhenesit || '');
        row.push(0);
        row.push(0);
        row.push(item.PunePrimare || '');
        row.push(item.PerfshihenKontributet || '');
        row.push(item.AplikohetTatimiNePaga || '');

        // Shtoni rreshtin në sheet
        worksheet.addRow(row);
    });

    // Kthej workbook-in për përdorim në komponentin tjetër
    return workbook;
};
